import type { ReactElement } from 'react';

import BpkImage, {
  BORDER_RADIUS_STYLES,
  withLazyLoading,
  withLoadingBehavior,
} from '@skyscanner-internal/backpack-web/bpk-component-image';
import {
  BpkHStack,
  BpkSpacing,
  BpkVessel,
} from '@skyscanner-internal/backpack-web/bpk-component-layout';
import BpkLink from '@skyscanner-internal/backpack-web/bpk-component-link';
import BpkText, { TEXT_STYLES } from '@skyscanner-internal/backpack-web/bpk-component-text';
import { GLOBAL } from 'saddlebag-browser';

import type { InternationalSite } from '@web-platform/shared-universal-types/src/apis/context/seoComponents';

import STYLES from './InternationalSiteCard.module.scss';

type Props = { siteData: InternationalSite; isAccordionExpanded: boolean };

const FLAG_URL = 'https://js.skyscnr.com/images/country/flag/header/';
const FLAG_EXTENSION = '.png';

const $document = GLOBAL.getDocument();
const documentIfExists = typeof window !== 'undefined' ? $document : null;
const LazyLoadedImage = withLoadingBehavior(withLazyLoading(BpkImage, documentIfExists));

const InternationalSiteCard = ({ isAccordionExpanded, siteData }: Props): ReactElement => {
  const { href, id, text } = siteData;

  const market = id.split('-')[0];

  return (
    <BpkHStack marginBottom={BpkSpacing.Base} gap={BpkSpacing.Base} paddingEnd={BpkSpacing.Base}>
      {/* BpkVessel required: img child selector sets explicit height because BpkImage's
          position:absolute img resolves height from content-box (0px), not padding-box.
          borderRadiusStyle prop on LazyLoadedImage replaces the previous broken
          img { border-radius } CSS which was clipped by the parent overflow:hidden. */}
      <BpkVessel className={STYLES.image}>
        <LazyLoadedImage
          src={`${FLAG_URL}${market.toLowerCase()}${FLAG_EXTENSION}`}
          altText=""
          aspectRatio={1}
          borderRadiusStyle={BORDER_RADIUS_STYLES.sm}
          data-testid="site-image"
        />
      </BpkVessel>
      <BpkLink href={href} implicit tabIndex={isAccordionExpanded ? 0 : -1}>
        <BpkText textStyle={TEXT_STYLES.footnote}>{text}</BpkText>
      </BpkLink>
    </BpkHStack>
  );
};

export default InternationalSiteCard;
